const getTotalNoOfPages = (totalRows, rowCount) => {
  const result = Math.ceil(totalRows / rowCount);
  return result;
};

export default getTotalNoOfPages;
